import React, { memo, useEffect, useState } from 'react';
import classNames from 'classnames';
import animateScroll from 'react-scroll/modules/mixins/animate-scroll';
import styles from './BackToTop.module.scss';

import { useCompareContext } from '../../context/CompareContext';

/**
 * Product Item Height - TODO:: This may be refactored at a later date.
 * @type {number}
 */
const productItemHeight = 400;
const backToTopThreshold = productItemHeight * 3;

type Props = {
  initialScroll: number;
};

const BackToTop = ({ initialScroll = 0 }: Props) => {
  const [scrollTop, setScrollTop] = useState(initialScroll);

  const { products } = useCompareContext();

  const isActive = scrollTop >= backToTopThreshold;

  const isComparing = products.length > 0;

  const className = classNames({
    [styles['back-to-top']]: true,
    [styles['back-to-top--active']]: isActive,
    [styles['back-to-top--compare-active']]: isComparing,
  });

  const setScrollPosition = () => setScrollTop(window.pageYOffset);

  const handleClick = () => {
    animateScroll.scrollToTop();
    // Focus is set to prevent screen readers "getting lost" when the button is activated
    const element = document.querySelector('[data-test="heading-term"]');
    if (element) {
      (element as HTMLElement).focus();
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', setScrollPosition);
    return () => {
      window.removeEventListener('scroll', setScrollPosition);
    };
  }, []);

  return (
    <div data-test="component-back-to-top" className={className}>
      <div className={styles['back-to-top__container']}>
        <button
          className={styles['back-to-top__button']}
          type="button"
          data-test="back-to-top-button"
          aria-label="Back to top"
          onClick={handleClick}
        >
          <span className={styles['back-to-top__text']}>
            Back to top button
          </span>
          <svg
            data-test="back-to-top-icon"
            className={styles['back-to-top__icon']}
            aria-labelledby="backToTopBtnTitle backToTopBtnDesc"
            viewBox="0 0 48 48"
          >
            <title id="BackToTopLargeIconTitle">Back to top icon</title>
            <desc id="BackToTopLargeIconDesc">
              An icon with an upward arrow inside a circle
            </desc>

            <path d="M24 48C10.8 48 0 37.2 0 24S10.8 0 24 0s24 10.8 24 24-10.8 24-24 24zm0-46.8C11.5 1.2 1.2 11.5 1.2 24S11.5 46.8 24 46.8 46.8 36.5 46.8 24 36.5 1.2 24 1.2z M32.7 22.9L24 14.1l-.7-.7-.7.7h-.1l-8.7 8.8.9.8 7.7-7.9v18H24v-18l7.9 7.9.8-.8z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default memo(BackToTop);
